import React from 'react';
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import {MAXFILESIZE, MAXTOTALFILESIZE} from '../../constants';
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginFileRename);

// eslint-disable-next-line max-params


const FilesUploadWarranty = ({document, handleImages, pdfLink}) => {
  return (
    <div>
      <div className="tcc-files-bottom-warranty mt mb-3">
        <div>
          <h5>Carga de formulario de inspección (solo admite PDF)
            <a download className="tcc-link" href={`${process.env.PUBLIC_URL}/media/tcc/TCC.pdf`}>
                Descargar formulario
            </a>
          </h5>
          <FilePond
            // disabled={validateStatus}
            maxFileSize={MAXFILESIZE}
            maxTotalFileSize={MAXTOTALFILESIZE}
            acceptedFileTypes={['application/pdf']}
            files={document}
            fileRenameFunction = {(file) => `document${file.extension}` }
            allowMultiple={false}
            onupdatefiles={(fileItems) => handleImages(fileItems, 'document')}
            labelIdle='Arrastrar archivo o <span class="filepond--label-action">Navegador</span>'
          />
          {pdfLink && (
            <div className="tcc-pdf-preview">
              <h5>Ver formulario de inspección</h5>
              <div className="tcc-pdf-preview-bg">
                <a target="_blank" rel="noreferrer" className="tcc-pdf-preview-bg-link" href={pdfLink}>
                  <img
                    className="tcc-pdf-preview-bg-image"
                    src={`${process.env.PUBLIC_URL}/media/tcc/TCC-PREVIEW.png`}
                    alt=""
                  />
                </a>
              </div>
            </div>
          )}
        </div>

     
      </div>
    </div>
  );
};

export default FilesUploadWarranty;
